<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
	<div class="row">
	  <div class="col-12"></div>
	  <div class="col-12">
		<div class="card">
		  <div class="card-content">
			<div class="card-body">
			  <!-- ngx-datatable-filter -->
			  <fieldset class="form-group">
				<div class="row align-items-end mt-0 pagination-body">
				  <div class="col-12 col-sm-12 col-md-3 col-lg-3 mb-2">
					<ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="40"
					[footerHeight]="40" rowHeight="auto" [limit]="limitRef" [rows]="rows" [externalPaging]="true"
					[count]="page.totalPages" [offset]="page.pageNumber" (page)="pageChangeData($event)"></ngx-datatable>
				  </div>
				  
				  <div class="col-12 col-sm-12 col-md-9 col-lg-9 mt-2 mb-1">
					<div class="row-flex">
					  <div class="col-flex-2 mb-1 position-relative">
						<input id="ngx-filter-ref"
						  class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
						  type="text" (keydown.enter)="filter(searchVal)" placeholder="Search" #name [(ngModel)]="searchVal"  />
						<button class="btn search-btn glow position-absolute" (click)="filter(searchVal)">
						  <i class="ft-search text-white cursor-pointer"></i>
						</button>
					  </div>
					  <div class="col-flex-2 mb-1">
						<button class="btn btn-primary btn-block users-list-clear glow mb-0" >
						  Reset
						  <i class="ft-filter text-white cursor-pointer"></i>
						</button>
					  </div>
					</div>
				  </div>
				  <!-- <div class="col-12">
					<button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Tags Guideline</button>
					</div> -->
				</div>
			  </fieldset>
			<div *ngIf="user_role.roles ==='employee'">
				<div *ngFor="let item of rows; let i=index">
					<div class="main_heading cursor-pointer" (click)="collapse.toggle()" [attr.aria-expanded]="assignmentView[i]"
					  aria-controls="collapseExample">
					  <h5 class="bg-light-info">
						{{item?.course?.title }} ({{item?.assignmentCount}})</h5>
					</div>
				  <ngx-datatable  #collapse="ngbCollapse" [(ngbCollapse)]="!assignmentView[i]" class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
					[footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="item.assignments" [scrollbarH]="true" [columns]="columns" 
					(page)="pageChangeData($event)">
					<ngx-datatable-column name="Title" prop="title" [width]="60">
					  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
						<div class="d-flex align-items-center">
						  <div class="cell-line-height">
							<p class="font-medium-1 line-height-1 mb-0">
							  {{ row?.title }}
							</p>
						  </div>
						</div>
					  </ng-template>
					</ngx-datatable-column>
					<ngx-datatable-column name="Student" prop="student_id" [width]="70">
						<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
						  <div class="cell-line-height">
							{{ row?.student_id?.user?.name }}
						  </div>
						</ng-template>
					  </ngx-datatable-column>
					  <ngx-datatable-column name="Course" prop="course_id" [width]="50">
						<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
						  <div class="cell-line-height">
							{{ item?.course?.title }}
						  </div>
						</ng-template>
					  </ngx-datatable-column>
					<ngx-datatable-column name="Grade" prop="grade" [width]="10">
						<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
						  <div class="cell-line-height cursor-pointer" (click)="openModalForAssignment(myModalContent,user_role.id,row?._id,row?.grade,'','Grade')">
							{{ row?.grade }}
						  </div>
						</ng-template>
					</ngx-datatable-column>
					<ngx-datatable-column name="Max Grade" prop="max_grade" [width]="10">
						<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
						  <div class="cell-line-height cursor-pointer">
							{{ row?.max_grade }}
						  </div>
						</ng-template>
					</ngx-datatable-column>
					<ngx-datatable-column name="Notes" prop="notes" [width]="70">
					  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
						<div class="cell-line-height cursor-pointer" (click)="openModalForAssignment(myModalContent,user_role.id,row?._id,'', row?.notes,'Notes')">
						  {{ row?.notes }}
						</div>
					  </ng-template>
					</ngx-datatable-column>
					<ngx-datatable-column name="Admin Notes" prop="admin_notes" [width]="70">
					  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
						<div class="cell-line-height cursor-pointer" (click)="openModalForAssignment(myModalContent,user_role.id,row?._id,'', row?.admin_notes,'Admin Notes')">
						  {{ row?.admin_notes }}
						</div>
					  </ng-template>
					</ngx-datatable-column>
					<ngx-datatable-column name="Actions" [width]="50"
					  *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
					  <ng-template let-row="row" ngx-datatable-cell-template>
						<i class="ft-edit text-primary cursor-pointer mr-2" [routerLink]="['/tags/tag-edit', row._id]"
						  (click)="editTag(row._id)"></i>
						<i *ngIf="user_role.roles ==='admin'" class="ft-trash-2 cursor-pointer danger"
						  (click)="ConfirmColor(row._id)"></i>
					  </ng-template>
					</ngx-datatable-column>
				  </ngx-datatable>
				  </div>
			</div>
			<ngx-datatable *ngIf="user_role.roles ==='admin'" class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows" [offset]="page.totalPages" [scrollbarH]="true" [columns]="columns" 
					(page)="pageChangeData($event)">
					<ngx-datatable-column name="Title" prop="title" [width]="60">
					  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
						<div class="d-flex align-items-center">
						  <div class="cell-line-height">
							<p class="font-medium-1 line-height-1 mb-0">
							  {{ row?.title }}
							</p>
						  </div>
						</div>
					  </ng-template>
					</ngx-datatable-column>
					<ngx-datatable-column name="Student" prop="student_id" [width]="50">
						<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
						  <div class="cell-line-height">
							{{ row?.student_id?.user?.name }}
						  </div>
						</ng-template>
					  </ngx-datatable-column>
					  <ngx-datatable-column name="Course" prop="course_id" [width]="70">
						<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
						  <div class="cell-line-height">
							{{ row?.course_id?.title }}
						  </div>
						</ng-template>
					  </ngx-datatable-column>
					  <ngx-datatable-column name="Grade" prop="grade" [width]="10">
						<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
						  <div class="cell-line-height cursor-pointer" (click)="openModalForAssignment(myModalContent,user_role.id,row?._id,row?.grade,'','Grade')">
							{{ row?.grade }}
						  </div>
						</ng-template>
					  </ngx-datatable-column>
					  <ngx-datatable-column name="Max Grade" prop="max_grade" [width]="10">
						<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
						  <div class="cell-line-height cursor-pointer" (click)="openModalForAssignment(myModalContent,user_role.id,row?._id,row?.max_grade,'','Max Grade')">
							{{ row?.max_grade }}
						  </div>
						</ng-template>
					</ngx-datatable-column>
					<ngx-datatable-column name="Notes" prop="notes" [width]="70">
					  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
						<div class="cell-line-height cursor-pointer" (click)="openModalForAssignment(myModalContent,user_role.id,row?._id,'', row?.notes,'Notes')">
						  {{ row?.notes }}
						</div>
					  </ng-template>
					</ngx-datatable-column>
					<ngx-datatable-column name="Admin Notes" prop="admin_notes" [width]="70">
					  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
						<div class="cell-line-height cursor-pointer" (click)="openModalForAssignment(myModalContent,user_role.id,row?._id,'', row?.admin_notes,'Admin Notes')">
						  {{ row?.admin_notes }}
						</div>
					  </ng-template>
					</ngx-datatable-column>
					<!-- <ngx-datatable-column name="Actions" [width]="50"
					  *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
					  <ng-template let-row="row" ngx-datatable-cell-template>
						<i class="ft-edit text-primary cursor-pointer mr-2" [routerLink]="['/tags/tag-edit', row._id]"
						  (click)="editTag(row._id)"></i>
						<i *ngIf="user_role.roles =='admin'" class="ft-trash-2 cursor-pointer danger"
						  (click)="ConfirmColor(row._id)"></i>
					  </ng-template>
					</ngx-datatable-column> -->
				  </ngx-datatable>
			  
			  <!-- ngx-datatable-filter -->
			</div>
		  </div>
		</div>
	  </div>
	</div>
  </section>
  <!--/ Filter Datatables -->
  <div class="d-flex justify-content-between align-items-center">
	<ngx-spinner></ngx-spinner>
  </div>
  
  
<!------------- Assignment Grade Update Popup --------------------------------------->
<div>
	<ng-template #myModalContent>
	  <div class="modal-header">
		<h4 class="modal-title">Assignment {{assignment_popup_name}} Update</h4>
		<button type="button" class="close" aria-label="Close" (click)="modalService.dismissAll()">
		  <span aria-hidden="true">&times;</span>
		</button>
	  </div>
	  <div class="modal-body">
		<div class="form-group"  *ngIf="assignment_popup_name ==='Grade'">
		  <label>Grade</label>
		  <input type="text" class="form-control" [(ngModel)]="assignment_model.grade" [ngModelOptions]="{standalone: true}" placeholder="Enter grade">
		</div>
		<div class="form-group"  *ngIf="assignment_popup_name ==='Max Grade'">
			<label>Max Grade</label>
			<input type="text" class="form-control" [(ngModel)]="assignment_model.max_grade" [ngModelOptions]="{standalone: true}" placeholder="Enter max grade">
		  </div>
		<div class="form-group"  *ngIf="assignment_popup_name ==='Notes' ">
			<label>Notes</label>
			<textarea class="form-control" [(ngModel)]="assignment_model.notes" [ngModelOptions]="{standalone: true}" name="notes" id="notes" cols="30" rows="4"></textarea>
		</div>
		<div class="form-group" *ngIf="assignment_popup_name ==='Admin Notes'">
			<label>Admin Notes</label>
			<textarea class="form-control" [(ngModel)]="assignment_model.admin_notes" [ngModelOptions]="{standalone: true}" name="admin_notes" id="admin_notes" cols="30" rows="4"></textarea>
		</div>

	  </div>
	  <div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Close</button>
		<button type="button" class="btn btn-primary" (click)="assignmentUpdate()">Update</button>
	  </div>
	</ng-template>
  </div>